import anime from 'animejs';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import toDataUrl from '../to-data-url';
import movingImage from '../moving-image';
import template from './template';

const iosFakeScrollTarget = document.createElement('div');

export default {
  disableScroll() {
    disableBodyScroll(iosFakeScrollTarget);
  },
  leave(data) {
    const link = data.trigger;
    const el = link.closest('.project-list-item');
    let waitImage;
    if (el) {
      const titleEl = el.querySelector('.page-title');
      const indexEl = el.querySelector('.project-list-item__index');
      const tagsEl = el.querySelector('.project-list-item__tags');
      const title = titleEl && titleEl.innerHTML;
      const shouldIndexTransition = indexEl && !('disableTransition' in indexEl.dataset);
      const { top, left } = titleEl.getBoundingClientRect();
      template.setPosition(left, top);
      template.setTitle(title);
      template.setIndex(shouldIndexTransition ? indexEl.textContent : ' ');
      template.setTags(tagsEl ? tagsEl.textContent : ' ');
      template.show();
      if (window.isMobile.any) {
        waitImage = toDataUrl(link.dataset.preview).then((b64) => {
          if (!document.body.contains(link)) return;
          movingImage.setImage(b64);
          movingImage.revealFullscreen();
        });
      } else {
        movingImage.expand();
      }
    }
    const leaveAnimation = () => anime({
      targets: data.current.container,
      opacity: 0,
      duration: 300,
      easing: 'easeOutQuad',
    }).finished;
    if (waitImage) {
      return waitImage.then(leaveAnimation);
    }
    return leaveAnimation();
  },
  enter(data) {
    const targetToCopy = data.next.container.querySelector('.cover .project-list-item');
    const onFinish = () => {
      enableBodyScroll(iosFakeScrollTarget);
      template.hide();
      anime({
        targets: data.next.container.children,
        duration: el => (el.classList.contains('cover') ? 0 : 200),
        opacity: 1,
        easing: 'easeOutQuad',
      });
    };
    if (targetToCopy) {
      // const tl = anime.timeline();
      anime.set(data.next.container.children, { opacity: 0 });
      anime({
        targets: template.element,
        translateX: targetToCopy.offsetLeft,
        translateY: targetToCopy.offsetTop,
        translateZ: 0,
        duration: 1100,
        easing: 'cubicBezier(.5,0,0,1)',
        complete: onFinish,
      });
      // tl.add({
      //   targets: targetToCopy,
      //   opacity: 1,
      //   duration: 200,
      //   easing: 'easeOutQuad',
      //   complete: () => {
      //     setTimeout(onFinish, 200);
      //   },
      // });
    }
  },
};
